import { ACTIVITIES_URL } from '@/utils/constants'

const ACTIVITIES = () => `${ACTIVITIES_URL}`

export default {
  ACTIVITIES
}